import { css } from 'lit';

/** Brand tokens + shared text styles, scoped inside every component shadow root. */
export const brandStyles = css`
  :host {
    /* These match :root in brand.css so components work in isolation too. */
    --av-black:   #000000;
    --av-gold:    #D0973D;
    --av-silver:  #808285;
    --av-white:   #FFFFFF;
    --bg:         #F4F4F4;
    --card:       #FFFFFF;
    --dark:       #111111;
    --border:     #E0E0E0;
    --text:       #1A1A1A;
    --muted:      #666666;
    --success:    #2E7D32;
    --danger:     #C62828;
    --warn:       #E65100;
    --font:       'Aptos', 'Segoe UI', system-ui, -apple-system, sans-serif;
    font-family: var(--font);
  }

  *, *::before, *::after { box-sizing: border-box; }
`;

export const buttonStyles = css`
  .btn-primary {
    background: var(--av-gold);
    color: var(--av-black);
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    border: none;
    border-radius: 3px;
    padding: 12px 28px;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  .btn-primary:hover   { opacity: 0.88; }
  .btn-primary:disabled{ opacity: 0.4; cursor: default; }

  .btn-secondary {
    background: none;
    border: 1px solid #333;
    color: var(--av-silver);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    padding: 11px 24px;
    border-radius: 3px;
    cursor: pointer;
    transition: border-color 0.2s, color 0.2s;
  }
  .btn-secondary:hover { border-color: var(--av-silver); color: var(--av-white); }

  .btn-nav {
    background: none;
    border: 1px solid var(--border);
    border-radius: 3px;
    padding: 9px 22px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s;
    color: var(--text);
  }
  .btn-nav:hover { border-color: var(--av-gold); color: var(--av-gold); }
  .btn-nav-primary {
    background: var(--av-gold);
    border-color: var(--av-gold);
    color: var(--av-black);
  }
  .btn-nav-primary:hover { opacity: 0.88; color: var(--av-black); }
  .btn-nav-locked {
    background: var(--bg);
    border: 1px solid var(--border);
    color: var(--muted);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    padding: 9px 18px;
    border-radius: 3px;
    cursor: not-allowed;
    white-space: nowrap;
  }
`;
